/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::42e1cef0652e5afc340d7d07e0411696>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Translate".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing language translations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const TranslateIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15.25 15v-.375l-1.056-2.375M7.75 15v-.375l1.056-2.375m0 0 2.444-5.5h.5l2.444 5.5m-5.388 0h5.388M0 3.75h4.75m0 0V1m0 2.75h1.5m0 0H9.5m-3.25 0c-.243 2.184-.78 4.015-1.568 5.55m0 0a11.5 11.5 0 0 1-3.307 3.95M4.682 9.3C3.868 8.311 3.184 7.155 2.75 6m1.932 3.3c.594.72 1.257 1.35 1.943 1.825"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
TranslateIcon.displayName = 'TranslateIcon';
var _default = exports.default = TranslateIcon;